import {VOORTGANG_CONTENT_TYPE, VoortgangRegel} from 'common';
import {getBackendUrl} from '@/base/frontendConfig.js';

export type Voortgang = {
    tekst: string;
    percentage?: number; // 0..100, undefined while the server works on a phase without a known size
};

export type UploadAntwoord = {
    status: number;
    body: unknown;
};

// POST a form (or a plain object as JSON) to the backend and report progress: the upload percentage, then the server's
// streamed steps (see common/voortgang.ts)
export function uploadMetVoortgang(path: string, body: FormData | object, meld: (v: Voortgang) => void): Promise<UploadAntwoord> {
    return new Promise<UploadAntwoord>((resolve, reject) => {
        const xhr: XMLHttpRequest = new XMLHttpRequest();
        let offset: number        = 0;

        function verwerkLijn(lijn: string): void {
            if (lijn.trim() === '') {
                return;
            }
            const regel: VoortgangRegel = JSON.parse(lijn);
            if (regel.type === 'voortgang') {
                const percentage: number | undefined = regel.totaal ? Math.round(100 * (regel.huidige ?? 0) / regel.totaal) : undefined;
                meld({tekst: regel.tekst, percentage: percentage});
            }
        }

        xhr.open('POST', getBackendUrl() + path);
        xhr.withCredentials = true;
        xhr.responseType    = '';

        xhr.upload.onprogress = (e: ProgressEvent): void => {
            if (e.lengthComputable) {
                meld({tekst: 'uploaden', percentage: Math.round(100 * e.loaded / e.total)});
            }
        };
        xhr.upload.onload = (): void => {
            meld({tekst: 'verwerken'});
        };
        xhr.onprogress = (): void => {
            const stuk: string      = xhr.responseText.slice(offset);
            const regels: string[]  = stuk.split('\n');
            regels.pop(); // het laatste stuk is nog onvolledig (of leeg als stuk op '\n' eindigde)
            for (const lijn of regels) {
                offset += lijn.length + 1;
                verwerkLijn(lijn);
            }
        };
        xhr.onload = (): void => {
            const contentType: string = xhr.getResponseHeader('Content-Type') ?? '';
            if (contentType.includes(VOORTGANG_CONTENT_TYPE)) {
                try {
                    const regels: string[]        = xhr.responseText.split('\n').filter(r => r.trim() !== '');
                    const laatste: VoortgangRegel = JSON.parse(regels[regels.length - 1]);
                    if (laatste.type === 'resultaat') {
                        resolve({status: laatste.status, body: laatste.body});
                    } else {
                        reject(new Error('geen resultaat in het antwoord'));
                    }
                } catch (_) {
                    reject(new Error('geen resultaat in het antwoord'));
                }
            } else {
                try {
                    resolve({status: xhr.status, body: JSON.parse(xhr.responseText)});
                } catch (_) {
                    resolve({status: xhr.status, body: undefined});
                }
            }
        };
        xhr.onerror = (): void => {
            reject(new Error('upload mislukt'));
        };
        xhr.onabort = (): void => {
            reject(new Error('upload mislukt'));
        };
        xhr.ontimeout = (): void => {
            reject(new Error('upload mislukt'));
        };

        if (body instanceof FormData) {
            xhr.send(body);
        } else {
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.send(JSON.stringify(body));
        }
    });
}
